import * as constants from "./../constants";

export interface ReceiveResultsFailureAction {
  type: constants.RECEIVE_RESULTS_FAILURE;
  error: any;
}
export function receiveResultsFailure(error: any): ReceiveResultsFailureAction {
  return {
    type: constants.RECEIVE_RESULTS_FAILURE,
    error,
  };
}
